const SPEEDSIZE_PREFIX='https://sfycdn.speedsize.com/a0aebe60-8b13-4e95-8aca-b006a78ac89f/'

const renderSnap = (snap) => {
  const items = snap.items.slice(0, 2).map(item => `<p class="fs-text">${item.key}：${item.value}</p>`).join('')
  return `
    <div class="fs-snap-card">
      <a href="#snap-modal-${snap.articleId}" data-article-id="${snap.articleId}">
        <div class="fs-image">
          <img
            src="${SPEEDSIZE_PREFIX}${snap.image.url.replace('width=1500', 'width=500')}"
            width="${snap.image.width}"
            height="${snap.image.height}"
            alt="${snap.model.name}"
            loading="lazy"
          />
        </div>
        <div class="fs-texts">
          ${items}
        </div>
      </a>
    </div>
    `
}

const SnapCardRenderer = () => {
  return {
    renderSnap: renderSnap
  }
}

export default SnapCardRenderer
